import { Button } from "../components/Button";
import { DomainChip } from "../components/DomainChip";
import { SectionHead } from "../components/SectionHead";
import { copy } from "../content/copy";
import { domains } from "../content/domains";
import { trackEvent } from "../lib/analytics";

export function ProductSection() {
  // Show all domains except "Other" (which is a form-only option).
  const featured = domains.filter((d) => d.id !== "other");
  return (
    <section className="section product" id="product">
      <div className="container">
        <SectionHead
          eyebrow={copy.product.eyebrow}
          title={
            <>
              Built for <span className="serif-italic">your stack</span> — not a generic one.
            </>
          }
          lede={copy.product.lede}
        />
        <div className="domain-grid">
          {featured.map((d) => (
            <DomainChip key={d.id} domain={d} />
          ))}
        </div>
        <div className="product-customize">
          <span className="product-customize__title">{copy.product.customizeTitle}</span>
          <p className="product-customize__body">{copy.product.customizeBody}</p>
        </div>
        <div className="product-cta">
          <Button
            as="a"
            href="#join"
            variant="primary"
            size="lg"
            onClick={() => trackEvent("cta_click", { location: "product_secondary" })}
          >
            {copy.product.cta} →
          </Button>
        </div>
      </div>
    </section>
  );
}
